import { render } from "./NoDoctor.vue?vue&type=template&id=a465fa6e"
import script from "./NoDoctor.vue?vue&type=script&lang=js"
export * from "./NoDoctor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__